"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const PopoverPortal_1 = __importDefault(require("../../Popover/PopoverPortal"));
const BackDrop_1 = __importDefault(require("../../Popover/BackDrop"));
const DrawerContext_1 = __importDefault(require("../../../contexts/DrawerContext"));
const NavContext_1 = __importDefault(require("../../../contexts/NavContext"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const helpers_1 = require("../../../lib/helpers");
const DrawerHeader_1 = __importDefault(require("./DrawerHeader"));
const animations_1 = require("../../../lib/config/animations");
const Drawer = (props) => {
    const { children } = props;
    const { drawerOpen, setDrawerOpen } = react_1.useContext(NavContext_1.default);
    const controls = framer_motion_1.useAnimation();
    const onDragEnd = react_1.useCallback((event, { offset, velocity }) => {
        const swipeDirection = helpers_1.getSwipeDirection(helpers_1.getSwipePower(offset.x, velocity.x));
        if (swipeDirection !== 'left') {
            controls.start('open')
                .catch(console.error);
        }
        else {
            setDrawerOpen(false);
        }
    }, [controls, setDrawerOpen]);
    react_1.useEffect(() => {
        controls.start(drawerOpen ? 'open' : 'closed').catch(console.error);
    }, [controls, drawerOpen]);
    const hasDrawerHeader = helpers_1.hasChildComponent(props, 'j-drawer-header');
    const dragProps = drawerOpen ? {
        drag: 'x',
        dragConstraints: { right: 0 },
        dragElastic: 0,
        dragMomentum: false,
        dragPropagation: false,
        onDragEnd,
    } : {};
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    const contextValue = react_1.useMemo(() => ({ inDrawer: true }), []);
    return (react_1.default.createElement(DrawerContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement(PopoverPortal_1.default, { selector: "body" },
            react_1.default.createElement(BackDrop_1.default, { isOpen: drawerOpen, onClick: () => setDrawerOpen(false) }),
            react_1.default.createElement(framer_motion_1.AnimatePresence, null, drawerOpen && (react_1.default.createElement(framer_motion_1.motion.div, Object.assign({}, dragProps, primitiveProps, { exit: "closed", initial: "closed", animate: controls, variants: animations_1.DrawerAnim.variants, transition: animations_1.DrawerAnim.transition }),
                !hasDrawerHeader && (react_1.default.createElement(DrawerHeader_1.default, { collapse: hasDrawerHeader }, children)),
                children))))));
};
exports.default = withJourney_1.default('j-drawer', Drawer);
